import { useMemo } from "react";
import { useAuth } from "@/auth/AuthProvider";
import { BaseListView } from "@/base";
import { hasCapability } from "@/lib/brokerAuth";
import { accountsListView } from "@/pages/accountsListView";
import { PageHeader } from "@/components/PageHeader";

// The brokerage's own accounts (BRK-S033), on BaseListView (BRK-S211): the
// definition in accountsListView.tsx says what the list shows and can ask PMS
// for; the base owns search, sort, paging, the layout and the states. Reading
// requires account:view.
//
// MOUNTED TWICE, ONE COMPONENT (BRK-S138). The Surety platform lists the SAME
// own-scoped accounts — there is no surety-specific account — so the only thing
// that differs is where a row goes: `/accounts/{id}` is the Commercial card,
// `/surety/accounts/{id}` the bond profile. A second list page would have been a
// copy that drifts in search, paging and empty states, so the destination is a
// prop and the platform is decided by the ROUTE (BRK-S090), not in here. There
// is no "Back to …" link (Nav, 2026-09-27): the sidebar is the way back.
export function AccountsListPage({
  /** Where a row goes. `/accounts` by default — the Commercial mount, which is
   *  also what a deep link with no platform gets. */
  basePath = "/accounts",
}: {
  basePath?: string;
} = {}) {
  const { identity, authedRequest } = useAuth();
  const canView = hasCapability(identity, "account:view");
  const canEdit = hasCapability(identity, "account:edit");
  const def = useMemo(
    () => accountsListView({ basePath, request: authedRequest, canEdit }),
    [basePath, authedRequest, canEdit],
  );

  return canView ? (
    <BaseListView def={def} />
  ) : (
    <section>
      <PageHeader title="Accounts" />
      <p role="alert" className="text-sm text-brk-danger">
        You don’t have access to view accounts.
      </p>
    </section>
  );
}
